<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <nav class="flex items-center justify-center mt-8" aria-label="Progress">
        <p class="text-sm font-medium text-white">{{ translate('step') }} {{ steps.findIndex((step) => step.status === 'current') + 1 }} {{translate('of')}} {{ steps.length }}</p>
        <ol role="list" class="ml-8 flex items-center space-x-5">
            <li v-for="step in steps" :key="step.name">
                <a v-if="step.status === 'complete'" :href="step.href" class="block w-2.5 h-2.5 bg-blue-600 rounded-full hover:bg-blue-900">
                    <span class="sr-only">{{ step.name }}</span>
                </a>
                <a v-else-if="step.status === 'current'" :href="step.href" class="relative flex items-center justify-center" aria-current="step">
                    <span class="absolute w-5 h-5 p-px flex" aria-hidden="true">
                        <span class="w-full h-full rounded-full bg-white" />
                    </span>
                    <span class="relative block w-2.5 h-2.5 bg-indigo-600 rounded-full" aria-hidden="true" style="z-index: 0"/>
                    <span class="sr-only">{{ step.name }}</span>
                </a>
                <a v-else :href="step.href" class="block w-2.5 h-2.5 bg-gray-200 rounded-full hover:bg-gray-400">
                    <span class="sr-only">{{ step.name }}</span>
                </a>
            </li>
        </ol>
    </nav>
</template>

<script>

import translate from "../../lang";
import {usePage} from "@inertiajs/inertia-vue3";

export default {
    props: {
        step: {
            type: Number,
            default: 1
        }
    },
    setup(props) {
        let steps = [
            { status: props.step === 1 ? 'current' : 'complete' },
            { status: (props.step === 2 ? 'current' : (props.step > 2 ? 'complete' : 'upcoming')) },
            { status: (props.step === 3 ? 'current' : (props.step > 3 ? 'complete' : 'upcoming')) },
            { status: (props.step === 4 ? 'current' : (props.step > 4 ? 'complete' : 'upcoming')) },
        ]

        return {
            steps,
            translate: translate('global.steps')
        }
    },
}
</script>
